export const BASE_URL = "https://api.zelta.io";
export const COMMUNITY_URL =
    "https://asia-south1-pbnative-403e0.cloudfunctions.net";
